module.exports = __webpack_public_path__ + "img/qyb.cca524ab.png";